export default "__VITE_ASSET__2p8UzVWV__"